export enum ActionType {
    Delete = 'Delete',
    Edit = 'Edit',
    View = 'View'
}